import React from "react";

import AvailableJobs from "./AvailableJobs";
const AvailableJobsMainPage = ({}) => {
  return (
    <div className="pt-[83px] max-w-[1440px] m-auto md:px-6 px-4">
      {" "}
      <AvailableJobs />
    </div>
  );
};

export default AvailableJobsMainPage;
